import undoable, { newHistory } from 'redux-undo';
import { dataSlice } from './data';
import { editorSlice } from './editor';

const undoableDataReducer = undoable(dataSlice.reducer);

export const reducer = (state, action) => {
  const editorState = editorSlice.reducer(state, action);
  let data = undoableDataReducer(state?.data, action);

  // Each page has its own undo stack — reset it to the freshly loaded content.
  if (action.type === editorSlice.actions.loadPage.type) {
    data = newHistory([], data.present, []);
  }

  return { ...editorState, data };
};

export { dataSlice, editorSlice };
